@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;
@use '../@shared/icon.mixin' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
	@include kol-icon-styles();

	.kol-input-number {
		input {
			appearance: textfield;
			text-align: right;

			&::-webkit-inner-spin-button {
				display: none;
			}
		}
	}
}
